/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import COLOR from "../../styles/color";
import FONT from "../../styles/font";
import Button from "../button/Button";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onClick: () => void;
}

const DeleteModal: React.FC<ModalProps> = ({ isOpen, onClose, onClick }) => {
  if (!isOpen) return null;

  return (
    <div css={modalBackground} onClick={onClose}>
      <div css={modalMain} onClick={(e) => e.stopPropagation()}>
        <div css={modalHeader}>
          <div css={modaltext}>
            <div css={{ marginBottom: "0.4rem" }}>
              삭제된 글은 복구할 수 없습니다.
            </div>
            <div>삭제하시겠습니까?</div>
          </div>
        </div>
        <div css={buttonBoxCSS}>
          <Button onClick={onClose} addCSS={buttonCSS}>
            취소하기
          </Button>
          <Button onClick={onClick} addCSS={buttonCSS}>
            삭제하기
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;

const modalBackground = css`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
`;

const modalMain = css`
  position: absolute;
  display: flex;
  width: 35rem;
  height: 11rem;
  background-color: ${COLOR.WHITE};
  border-radius: 1rem;
  flex-direction: column;
`;

const modalHeader = css`
  display: flex;
  justify-content: start;
  align-items: center;
  min-height: 7rem;
  border-bottom: 1px solid ${COLOR.GRAY4};
`;
const modaltext = css`
    display: flex;
    flex-direction: column;
    color: ${COLOR.BLACK};
    padding-left: 2rem;
    font-size: ${FONT.SIZE.BODY}
    font-weight: ${FONT.WEIGHT.REGULAR};
`;

const buttonBoxCSS = css`
  display: flex;
  justify-content: flex-end;
  margin: 1rem;
`;

const buttonCSS = css`
  margin-right: 0.5rem;
  background: ${COLOR.MAIN};

  &:hover {
    background-color: ${COLOR.MAIN2};
  }
`;

// const exitButtonCSS = css`
//   margin-right: 0.5rem;
// `;
